import { LINKEDIN, META, TIKTOK } from "../../utils/constants";
import { useAdvertiserPlatformDefaults } from "./useAdvertiserPlatformDefaults";

const SHARE_MODAL_DEFAULT_PLATFORMS = [META, TIKTOK, LINKEDIN];

/**
 * Loads Settings Default Campaign Settings for ShareModal account prefills.
 * Skips loading while the modal is closed or while editing scheduled content.
 */
export const usePlatformDefaultsInShareModal = ({
  modalOpen = false,
  isEditing = false,
} = {}) => {
  const { platformDefaults, isLoaded: isPlatformDefaultsLoaded } =
    useAdvertiserPlatformDefaults({
      platforms: SHARE_MODAL_DEFAULT_PLATFORMS,
      enabled: modalOpen && !isEditing,
    });

  return {
    platformDefaults,
    isPlatformDefaultsLoaded,
  };
};

export default usePlatformDefaultsInShareModal;
